import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Chart from '../../../../../../common/components/Chart/Chart';
import Loading from '../../../../../../common/components/Loading/Loading';
import { getReport } from './Subreport.actions';
import './Subreport.css';

const _buildState = props => ({
  isFetching: true,
  params: props.subreportParams,
  chartData: {}
});

class Subreport extends Component {
  constructor(props) {
    super(props);
    this.state = _buildState(props);
  }

  componentWillReceiveProps(newProps, oldProps) {
    this.setState(() => _buildState(newProps), () => this._fetchData());
  }

  componentDidMount() {
    this._fetchData();
  }

  render() {
    return (
      <div className="height-placeholder">
        <Loading condition={this.state.isFetching}>
          <div className="u-mb-full" data-qa="qa-subreport-chart">
            <Chart config={this.state.chartData.Configuration} metadata={this.state.metadata} />
          </div>
        </Loading>
      </div>
    );
  }

  _fetchData = () => {
    this.setState({ isFetching: true });
    getReport(this.state.params)
      .then(res => this._processData(res.body))
      .catch(e =>
        this.setState({
          isFetching: false
        })
      );
  };

  _processData = data => {
    if (data) {
      var resChart = Object.assign({}, data.find(config => config.Name === 'Chart'));
      const resMetadata = Object.assign({}, data.find(config => config.Name === 'Metadata'));
      const resMetadataDataFirstKey = Object.keys(resMetadata.Data)[0];
      const resMetadataData = resMetadata.Data[resMetadataDataFirstKey];

      resChart.Configuration.series = resChart.Configuration.series.filter((n) => n.data.length != 0);

      this.setState({
        chartData: resChart,
        metadata: resMetadataData,
        isFetching: false,
        data
      });
    } else {
      this.setState({
        isFetching: false
      });
    }
  };
}

Subreport.propTypes = {
  subreportParams: PropTypes.object
};

Subreport.defaultProps = {
  subreportParams: {}
};

export default Subreport;
